import React, { Component } from 'react'
import PropTypes from 'prop-types'
import MainLayout from 'components/MainLayout'
import { Container } from 'components/layout/Grid/'
import BackToAdminCentre from 'components/BackToAdminCentre'
import BackTo from 'components/BackTo'
import RouteWithSubRoutes from 'components/RouteWithSubRoutes'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { hasAccess } from 'utils/hasAccess'
import { headerTitleName } from 'utils/headerTitleName'
import { commonFunctions } from 'utils/CommonFunctions'

class AccountsAndLoans extends Component {
  static propTypes = {
    currentUser: PropTypes.object,
    routes: PropTypes.instanceOf(Array),
    // eslint-disable-next-line react/no-unused-prop-types
    selectedPartner: PropTypes.object,
  }
  static defaultProps = {
    routes: {},
    selectedPartner: null,
    currentUser: null,
  }

  componentDidMount() {
    hasAccess(this.props.currentUser, 'Accounts and Loans', this.props.history)
  }

  bannerProps = () => {
    const {
      routes, history, location, match, path,
    } = this.props
    return {
      name: headerTitleName(this.props.currentUser, (window.location.href.indexOf('accountsandloans/transactions') > -1 ? 'Account transactions' : 'Accounts & loans')),
      history,
      location,
      path,
      match,
      routes,
    }
  }

  render() {
    const { routes, currentUser, selectedPartner, accountsAndLoans } = this.props
    return (
      <MainLayout
        bannerNavProps={{ ...this.bannerProps() }}
        partnerSideBarInfo={commonFunctions.checkPartnerSideBar(this.props)}
        showSidebar={!(window.location.href.indexOf('accountsandloans/transactions') > -1)}
        sidebarType="partnerSideBar"
      >
        { window.location.href.indexOf('accountsandloans/transactions') > -1
        ? <BackTo displayText={`Account No. ${accountsAndLoans.selectedAccount.AccountNo} - ${accountsAndLoans.selectedAccount.LegalName}`} history={this.props.history} />
        : <BackToAdminCentre displayText={`${selectedPartner.Name}: Accounts & loans`} isAdmin={currentUser.IsAdmin} /> }
        <Container>
          {routes.map((route, i) => (
            <RouteWithSubRoutes
              key={i}
              {...route}
              accountsAndLoans={accountsAndLoans}
              currentUser={currentUser}
            />
             ))}
        </Container>
      </MainLayout>
    )
  }
}

const mapStateToProps = state => ({
  accountsAndLoans: state.accountsAndLoans,
  selectedPartner: (Object.keys(state.personalinfos.selectedPartner).length === 0 && sessionStorage.getItem('SelectedPartner') !== null ?
    JSON.parse(sessionStorage.getItem('SelectedPartner')) :
    state.personalinfos.selectedPartner),
})

export default withRouter(connect(mapStateToProps, {})(AccountsAndLoans))



// WEBPACK FOOTER //
// ./src/containers/AccountsAndLoans.js